import React from "react";

type Exercise = { id: string; name: string };
type Plan = { id: string; name: string; date?: string; exercises: Exercise[] };
type ExerciseProgress = {
  completed?: boolean;
  setsCompleted?: number;
  reps?: number;
  weight?: number;
  notes?: string;
};

export default function TodayWorkout({
  plan,
  progress,
  onUpdate,
}: {
  plan: Plan;
  progress: Record<string, ExerciseProgress>;
  onUpdate: (id: string, data: ExerciseProgress) => void;
}) {
  if (!plan) return null;
  const today = plan.date ? new Date(plan.date) : new Date();
  const dateStr = today.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <strong>Today&apos;s Workout</strong>
        <span style={styles.date}>{dateStr}</span>
      </div>
      <div style={styles.exercisesList}>
        {plan.exercises.map((ex) => {
          const pr = progress[ex.id] || {};
          return (
            <div key={ex.id} style={styles.exerciseRow}>
              <input
                type="checkbox"
                checked={!!pr.completed}
                onChange={(e) =>
                  onUpdate(ex.id, { ...pr, completed: e.target.checked })
                }
                style={styles.checkbox}
                aria-label={`Mark ${ex.name} as completed`}
              />
              <span style={styles.exerciseName}>{ex.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles: { [k: string]: React.CSSProperties } = {
  card: {
    backgroundColor: "#2a2a2a",
    borderRadius: 8,
    padding: 12,
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  date: { fontSize: 12, color: "#ccc" },
  exercisesList: { display: "flex", flexDirection: "column", gap: 8 },
  exerciseRow: { display: "flex", alignItems: "center", gap: 8 },
  checkbox: { width: 20, height: 20 },
  exerciseName: { fontSize: 14 },
};
